import { NgModule } from '@angular/core';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '../../shared/shared.module';
import { RegisterComponent } from './register/register.component';
import { CalendarModule } from 'primeng/calendar';
import { EditProfileComponent } from './edit-profile/edit-profile.component';


@NgModule({
    declarations: [LoginComponent, RegisterComponent, EditProfileComponent],
    imports: [
        SharedModule,
        AuthenticationRoutingModule,
        CalendarModule
    ]
})
export class AuthenticationModule {
}
